<template>

    <li class="nav-item d-none d-sm-inline-block">
        <!-- Notification -->
        <div class="dropdown">
            <button type="button" class="btn btn-ghost-secondary btn-icon rounded-circle"
                id="navbarNotificationsDropdown" data-bs-toggle="dropdown" aria-expanded="false"
                data-bs-auto-close="outside" data-bs-dropdown-animation="" @click="isReading = true">
                <i class="bi-bell"></i>
                <span class="btn-status btn-sm-status btn-status-danger" v-if="!isReading"></span>
            </button>

            <div class="dropdown-menu dropdown-menu-end dropdown-card navbar-dropdown-menu navbar-dropdown-menu-borderless"
                aria-labelledby="navbarNotificationsDropdown" style="width: 25rem; opacity: 1;">
                <!-- Header -->
                <div class="card-header card-header-content-between">
                    <h4 class="card-title mb-0">Notifications</h4>

                    <!-- Unfold -->
                    <div class="dropdown">
                        <button type="button" class="btn btn-icon btn-sm btn-ghost-secondary rounded-circle"
                            id="navbarNotificationsDropdownSettings" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi-three-dots-vertical"></i>
                        </button>


                    </div>
                    <!-- End Unfold -->
                </div>

                <div class="card-body-height">
                    <ul class="list-group list-group-flush navbar-card-list-group">
                        <!-- Item -->
                        <li class="list-group-item form-check-select" v-for="(notification, i) in notifications"
                            :key="i">
                            <div class="row">
                                <div class="col-auto">
                                    <div class="d-flex align-items-center">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value=""
                                                id="notificationCheck2" checked="">
                                            <label class="form-check-label" for="notificationCheck2"></label>
                                            <span class="form-check-stretched-bg"></span>
                                        </div>
                                        <div class="avatar avatar-sm avatar-soft-dark avatar-circle">
                                            <span class="avatar-initials">K</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col ms-n2">
                                    <h5 class="mb-1">{{ notification.title }}</h5>
                                    <p class="text-body fs-5">{{ notification.body }}</p>

                                </div>
                                <!-- End Col -->

                                <small class="col-auto text-muted text-cap">10hr</small>
                                <!-- End Col -->
                            </div>
                            <!-- End Row -->

                            <a class="stretched-link" href="#"></a>
                        </li>
                    </ul>
                </div>
                <!-- End Body -->

                <!-- Card Footer -->

                <router-link class="card-footer text-center" :to="{ name: 'NotificationList' }">
                    Voir toutes les notifications
                    <i class="bi-chevron-right"></i>
                </router-link>

                <!-- End Card Footer -->
            </div>
        </div>
        <!-- End Notification -->
    </li>
    <li class="nav-item">
        <div class="dropdown">
            <a class="navbar-dropdown-account-wrapper" href="javascript:;" id="accountNavbarDropdown"
                data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside" data-bs-dropdown-animation>
                <div class="avatar avatar-sm avatar-circle">
                    <img class="avatar-img" src="@/assets/img/cpd-profil.jpg" alt="Image Description">
                    <span class="avatar-status avatar-sm-status avatar-status-success"></span>
                </div>
            </a>

            <div class="dropdown-menu dropdown-menu-end navbar-dropdown-menu navbar-dropdown-menu-borderless navbar-dropdown-account"
                aria-labelledby="accountNavbarDropdown" style="width: 16rem;">
                <div class="dropdown-item-text">
                    <div class="d-flex align-items-center">
                        <div class="avatar avatar-sm avatar-circle">
                            <img class="avatar-img" src="@/assets/img/cpd-profil.jpg" alt="Image Description">
                        </div>
                        <div class="flex-grow-1 ms-3">
                            <router-link :to="{ name: 'UserAuthProfile' }">
                                <h5 class="mb-0">{{ user?.firstname }} {{ user?.lastname }}</h5>

                                <p class="card-text text-body">{{ user?.email }}</p>
                            </router-link>
                            <!-- <h5 class="mb-0">{{ user?.firstname }} {{ user?.lastname }}</h5>

                            <p class="card-text text-body">Superviseur</p> -->
                        </div>
                    </div>
                </div>

                <div class="dropdown-divider"></div>

                <a class="dropdown-item cusor" @click="logout">Déconnexion</a>
            </div>
        </div>
        <!-- End Account -->
    </li>
</template>
<script>
import { mapFields } from 'vuex-map-fields';
import { mapActions } from 'vuex';


export default {
    name: "UsersHeader",
    computed: {
        ...mapFields("auth/user", {
            user: "item"
        }),
        ...mapFields("notification/list", {
            notifications: "items",
            isLoading: 'isLaoding',
            isReading: "isReading"
        }),
    },
    methods: {

        ...mapActions({
            logout: "auth/user/logoutUser"
        })
    },

    watch: {

    }
}
</script>
<style scoped>
.small-badge {
    font-size: 0.6rem;
    padding: 0.2rem 0.4rem;
}

.cusor {
    cursor: pointer;
}
</style>